import { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatLocalDateTime } from "../../utils/formatDate";
import FuncionarioService from "../../services/resource/funcionarioService";
import FaltaService from "../../services/resource/FaltaService";

function TabelaAfastamentos({ data, ano, mes }) {
    const funcionarioService = new FuncionarioService();
    const faltaService = new FaltaService();

    const [loading, setLoading] = useState(true);
    const [afastamentos, setAfastamentos] = useState([]);

    const values = {
        funcionarioId: data.funcionarioId,
        ano: ano,
        mes: mes,
        tipoDistribuidor: data.tipoDistribuidor,
        funcionarioCodigo: data.funcionarioCodigo
    }

    useEffect(() => {
        setLoading(true);

        Promise.all([
            funcionarioService.listarAfastamentos(values),
            faltaService.listarAfastamentos(values)
        ])
            .then(([resFuncionarios, resFaltas]) => {
                setAfastamentos([
                    ...resFuncionarios.data,
                    ...resFaltas.data
                ]);
            })
            .finally(() => setLoading(false));

    }, []);

    return (
        <div>

            <div className="m-4 rounded-md border border-amber-300 bg-amber-50 p-4 text-sm text-amber-800">
                <p>
                    As informações de <span className="font-semibold text-amber-900">férias, fastamentos e faltas </span> são  integradas diretamente ao sistema
                    <span className="font-bold text-amber-900"> Fortes RH</span>.
                    <br /><br />
                    Caso seja identificada qualquer inconsistência nesses dados, é necessário solicitar o
                    <span className="font-semibold text-amber-900"> ajuste ao setor de RH</span> e, após a correção, comunicar a equipe responsável para que as
                    <span className="font-bold text-amber-900"> comissões sejam recalculadas</span>.
                </p>
            </div>

            <DataTable
                value={afastamentos}
                loading={loading}
                scrollable
                scrollHeight="450px"
                dataKey="id"
                size="small"
                className="text-[12px] custom-datatable text-foreground border border-border cursor-default"
                rowClassName="text-[12px] border-b border-border min-w-[400px] text-foreground cursor-default"
                Menu={false}
                emptyMessage="Nenhuma carga encontrada."
                footer={() => (
                    <div className="flex justify-between items-center p-2 font-semibold text-[12px]">
                        <div>
                            Total de afastamentos: {afastamentos.length}
                        </div>
                    </div>
                )}>

                <Column
                    field="funcionarioNome"
                    header="Funcionario"
                    sortable
                    Menu={false}
                    className="px-3"
                    style={{ minWidth: "140px" }}
                />

                <Column
                    field="funcionarioCodigo"
                    header="Código"
                    sortable
                    Menu={false}
                    className="px-3"
                    style={{ minWidth: "140px" }}
                />

                {/* DATA */}
                <Column
                    field="dataInicial"
                    header="Data Início"
                    body={(row) => formatLocalDateTime(row.dataInicial)}
                    sortable
                    style={{ minWidth: "140px" }}
                />

                <Column
                    field="dataFinal"
                    header="Data Fim"
                    body={(row) => formatLocalDateTime(row.dataFinal)}
                    sortable
                    style={{ minWidth: "140px" }}
                />

                <Column
                    field="diasAfastados"
                    header="Dias Afastados"
                    sortable
                    style={{ minWidth: "140px" }}
                />

                <Column
                    field="motivo"
                    header="Motivo"
                    sortable
                    Menu={false}
                    className="px-3"
                    style={{ minWidth: "140px" }}
                />
            </DataTable>

        </div>
    );
}

export default TabelaAfastamentos;